import WelcomeImageInspector from './WelcomeImageInspector';
import EventCalendarInspector from './EventCalendarInspector';
import MediaAssetInspector from './MediaAssetInspector';
import ContentSectionInspector from './ContentSectionInspector';
import MessageSectionInspector from './MessageSectionInspector';
import LocationSectionInspector from './LocationSectionInspector';
import DressCodeSectionInspector from './DressCodeSectionInspector';
import ThankYouSectionInspector from './ThankYouSectionInspector';
import CountdownContainerInspector from './CountdownContainerInspector';
import AttendanceQuestionsInspector from './AttendanceQuestionsInspector';
import SpotifySectionInspector from './SpotifySectionInspector';

// Map component names to their custom inspectors
export const customInspectors = {
  WelcomeImage: WelcomeImageInspector,
  EventCalendar: EventCalendarInspector,
  MediaAsset: MediaAssetInspector,
  ContentSection: ContentSectionInspector,
  MessageSection: MessageSectionInspector,
  LocationSection: LocationSectionInspector,
  DressCodeSection: DressCodeSectionInspector,
  SpotifySection: SpotifySectionInspector,
  AttendanceQuestions: AttendanceQuestionsInspector,
  CountdownContainer: CountdownContainerInspector,
  ThankYouSection: ThankYouSectionInspector,
};

// Helper function to get the appropriate inspector
export const getInspector = (componentName) => {
  return customInspectors[componentName] || null;
}; 